enum FileType {
  ProjectMembers = 'Project Members',
  ProjectSchedule = 'Project Schedule',
  ProjectMaterials = 'Project Materials',
  Image = 'Image',
  Pdf = 'Pdf',
  Excel = 'Xlsx',
  Word = 'Docx',
  PowerPoint = 'Pptx',
  Video = 'Video',
  OtherFile = 'OtherFile',
}

export const AttachmentFileTypeList = [
  FileType.Image,
  FileType.Pdf,
  FileType.Excel,
  FileType.Word,
  FileType.PowerPoint,
  FileType.Video,
  FileType.OtherFile,
]

export default FileType
